export default function CsharpForLoop() {
  return (
    <h2>Csharp For Loop</h2>
  );
}
